module.exports = __webpack_public_path__ + "static/media/page5.43344116.png";